export default {
  // createtask: '创建任务',
  // businessinfo: '任务设计',
  // detailinfo: '详细信息',
  // offer: '设置报价',
  // fillexample: '填写样例',
  // course: '教程',
  // goback: '上一步',
  // save: '保存',
  // next: '下一步',
  baseinfo: {
    datasource: '数据源',
    fileformat: '文件格式',
    other: '其他',
    otherformat: '请填写其他文件格式',
    note: '备注',
    skill: '采集员或标注员所需技能',
    ski: '所需技能',
    dataqualified: '数据合格标准',
    qualified: '合格标准',
    valcriterion: '有效性判断准则',
    criterion: '判断准则',
    js: {
      rules: {
        format: '请至少选择一个文件格式',
        formatOther: '请填写文件格式',
        qualified: '请填写合格标准',
        skill: '请填写所需技能',
        criterion: '请填写有效性判断准则'
      }
    }
  },
  business: {
    wholemap: '全局题目设置',
    singlechoice: '单选题',
    multiplechoice: '多选题',
    fillblank: '填空题',
    labelproblem: '标注项问题',
    entercontent: '请输入内容',
    preview: '预览模板',
    taskintro: '任务介绍',
    taskbref: '任务简介',
    tasktime: '任务时间',
    starttime: '起止时间',
    to: '至',
    startdate: '开始日期',
    stopdate: '结束日期',
    unsatisfy: '模板不满意？',
    service: '我要定制专属服务！',
    js: {
      rules: {
        brief1: '请填写任务简介',
        brief2: '长度128个字符以内',
        introduce1: '请填写任务介绍',
        introduce2: '长度1024个字符以内',
        date1: '请选择起止时间'
      },
      title: '题目',
      label: '选项',
      labelContent: '选项含义',
      text: '填空题'
    }
  },
  qcprice: {
    datascale: '数据规模',
    picturenum: '文本数量',
    zhang: '个',
    picturequality: '文本质量',
    selectpicquality: '请选择文本质量',
    estimate: '任务预估时间',
    minute: '分钟（每个任务标注预估耗时）',
    qualitytest: '质检方式',
    selectquatest: '请选择质检方式',
    priceratio: '审核价格比例',
    scale: '（审核任务的报酬占做任务的的报酬比例）',
    checkrate: '抽检比例',
    spotnumber: '抽查数量',
    taskprice: '审核任务单价',
    integral: '泛函币/个',
    total: '累计答案',
    checktimes: '检查次数',
    time: '次',
    checknumber: '检查数量',
    perzhang: '个/个',
    moreamount: '人/个（每个数据最多多少人做）',
    labelnum: '标注人数',
    leastlabel: '至少标注',
    morelabel: '最多标注',
    rate: '比例',
    expectlabel: '预计标注',
    quote: '报价',
    quotenote: '如果您愿意给到标注员100泛函币作为劳动报酬，泛函将额外收取30泛函币作为平台服务费，您总共需要支付130泛函币。',
    suggestprice: '建议价格',
    leastprice: '最低价格',
    unitprice: '您愿意给到标注员的劳动报酬',
    totalprice: '审核任务总价',
    sumprice: '总价',
    inter: '泛函币',
    leftpart: '【',
    rightpart: '】',
    js: {
      rules: {
        num1: '数量不能为空',
        num2: '数量必须为数字值',
        scale1: '数据大小不能为空',
        scale2: '数据大小必须为数字值',
        thisQuality: '请选择文本质量',
        taskTime1: '任务预估时间不能为空',
        taskTime2: '任务预估时间必须为数字值',
        checkType: '请选择质检方式',
        checkProportion1: '不能为空',
        checkProportion2: '必须为数字值',
        spotCheck1: '抽检比例不能为空',
        spotCheck2: '抽检比例必须为数字值',
        allCheckNum1: '全检次数不能为空',
        allCheckNum2: '全检次数必须为数字值',
        rightAnswer1: '不能为空',
        rightAnswer2: '必须为数字值',
        tagNumber1: '标注人数不能为空',
        tagNumber2: '标注人数必须为数字值',
        goldTest1: '不能为空',
        goldTest2: '必须为数字值',
        offer1: '客户单价不能为空',
        offer2: '客户单价必须为数字值'
      }
    }
  },
  sample: {
    name: '名称',
    describe: '描述',
    exampledata: '样例数据',
    selectexamdata: '请选择样例数据',
    uploadnewfile: '上传新文件',
    confirm: '确定',
    reset: '取消',
    filename: '文件名',
    filesize: '大小',
    operate: '操作',
    remove: '移除',
    lessupload: ' 只能上传音频文件，且不超过20Mb',
    clickupload: '点击上传文件',
    save: '保存',
    trueexample: '正确样例列表',
    addexample: '添加样例',
    delete: '删除',
    errorexample: '错误样例列表',
    js: {
      rules: {
        name1: '请输入名称',
        name2: '长度在 1 到 10 个字符',
        selectExample: '请选择样例数据'
      },
      addStatus: {
        type1: '修改答案',
        type2: '添加答案'
      },
      success: {
        type1: '成功',
        type2: '确定',
        type3: '删除成功',
        type4: '上传成功',
        type5: '添加成功'
      },
      error: {
        type1: '失败',
        type2: '警告',
        type3: '取消',
        type4: '图片上传出错，请刷新重试！',
        type5: '每个用户最多上传10个文件',
        type6: '文件太大'
      },
      deleteSampleFile: '移除文件后，对应的样例也会被删除,是否继续',
      deleteSampleItem: '样例正被删除,是否继续?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/pushtext.js